export enum enumLoginType {
    VNPT = 'vnpt',
    GOOGLE = 'google',
    SME = 'sme',
}